import { fetchProductLevels } from '../api/iris';
import NetworkBinding from 'growth-payments-core/binding/networkBinding';
import { HubProducts, ProductLevel } from '../types/products';
import { createNetworkHook } from 'growth-payments-core/binding/useNetworkBinding';
import { getNetworkBindingData } from '../binding/getNetworkBindingData';
import { registerQuery, useQuery } from 'data-fetching-client';
export const AllHubProducts = Object.values(HubProducts);
const productLevelOrder = [ProductLevel.NONE, ProductLevel.STARTER, ProductLevel.PRO, ProductLevel.ENTERPRISE];
export function calculateHighestLevelFromProducts(levels) {
  const highestIndex = Object.values(levels).reduce((highest, current) => {
    const index = productLevelOrder.indexOf(current);
    return Math.max(index, highest);
  }, -1);
  return highestIndex === -1 ? undefined : productLevelOrder[highestIndex];
}
export function fetchHighestProductLevel(products = AllHubProducts) {
  return fetchProductLevels(products).then(productLevels => {
    return calculateHighestLevelFromProducts(productLevels);
  });
}
export const HighestProductLevelBinding = new NetworkBinding(fetchHighestProductLevel);

/**
 * @deprecated Use useHighestProductLevelDFC instead
 */
export const useHighestProductLevel = createNetworkHook(HighestProductLevelBinding);
export const getHighestProductLevelFromBinding = () => getNetworkBindingData(HighestProductLevelBinding);
export const HIGHEST_PRODUCT_LEVEL_QUERY = registerQuery({
  fieldName: 'highestProductLevel',
  args: ['products'],
  fetcher: ({
    products
  }) => fetchHighestProductLevel(products)
});
export const useHighestProductLevelDFC = (products = AllHubProducts, options) => {
  return useQuery(HIGHEST_PRODUCT_LEVEL_QUERY, {
    variables: {
      products
    },
    skip: options === null || options === void 0 ? void 0 : options.skip
  });
};